import { Link } from 'react-router-dom'
import { Alert, ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'

const ENTITIES = ['Invoice', 'Bill', 'Expense', 'Customer', 'Vendor', 'Product / Service']

export function LiveEditPage() {
  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Live edit
          </div>
          <h2>Live edit</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            A spreadsheet view straight onto QuickBooks. Edit cells, then push only the changed rows.
          </p>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">P1</span>
        <span className="pill">1 credit per changed line</span>
      </div>

      <ComingSoonBanner feature="Live edit" />

      <div className="card" style={{ marginBottom: 14 }}>
        <div className="card-p" style={{ padding: '14px 16px' }}>
          <div className="row">
            <select className="inp" style={{ width: 180 }} defaultValue={ENTITIES[0]}>
              {ENTITIES.map((name) => (
                <option key={name}>{name}</option>
              ))}
            </select>
            <input className="inp mono" style={{ width: 130 }} defaultValue="2026-01-01" />
            <span className="faint">→</span>
            <input className="inp mono" style={{ width: 130 }} defaultValue="2026-01-31" />
            <input
              className="inp"
              style={{ flex: 1, minWidth: 150 }}
              placeholder="Filter customer, memo, amount…"
            />
            <button className="btn btn-g btn-sm" type="button" disabled>
              Load rows
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-h">
          <h3>Grid</h3>
          <span className="spacer" />
          <span className="fs12 faint">
            Tab to move · Enter to commit a cell · unsaved cells are outlined
          </span>
        </div>
        <EmptyState
          icon="▦"
          title="Nothing loaded"
          body="Live edit reads records straight out of QuickBooks. The read endpoint is not part of the current API, so the grid stays empty for now."
        />
        <div className="card-f">
          <span className="fs13 muted">0 rows</span>
          <span className="spacer" />
          <button className="btn btn-g btn-sm" type="button" disabled>
            Reload
          </button>
        </div>
      </div>

      <Alert tone="info" title="Rows with errors are held back when you push" style={{ marginTop: 16 }}>
        A cell that does not resolve to a QuickBooks record — a misspelt customer, say — is flagged
        in the row before you spend a credit on it. You can create the missing record from{' '}
        <Link to="/app/quick-create">Quick create</Link> and push again.
      </Alert>
    </div>
  )
}
